import { Card, FormControlLabel, Grid, RadioGroup, TextareaAutosize, Typography } from '@mui/material';
import styles from '../contactUs/contactus.module.scss'
import { useEffect, useState } from 'react';
import { ValidationError, object, string } from 'yup';
import toast, { Toaster } from 'react-hot-toast';
import { CommonButton, CustomCheckbox, CustomRadioButton, CustomRequiredInputLabel, CustomTextFeild } from '../common/StyledComponents/StyledFields';
import { apiRequest, catchErrorMessageHandler } from '../../infrastructure/backendService';
import ToastError from '../common/toast/toastError';
import ToastSuccess from '../common/toast/toastSuccess';
import apiPath from '../../config/apiPaths.json'
import { isNil } from 'lodash';
import LOCALE from '../../config/en-us.json'
import ReCAPTCHA from "react-google-recaptcha";
import constants from "../../config/constants.json"
import SuccessPopup from '../devotee/donation/successPopup';
import ErrorPopup from '../common/ErrorPopup';


interface ErrorMessageTypes {
    name: string;
    email: string;
    description: string;
}
const Feedback = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedValue, setSelectedValue] = useState<number | null>(null);
    const [categoriesList, setcategoriesList] = useState<any[]>([]);
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        President: false,
        Chairman: false,
        description: ""
    })
    const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
        name: "",
        email: "",
        description: ""
    })

    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const validationSchema = object().shape({
        name: string().required('Name is required'),
        email: string()
            .required('Email is required')
            .matches(emailRegex, 'Please enter valid email address')
            .min(6, 'Email must be at least 6 characters')
            .max(64, 'Email cannot exceed 64 characters'),
        description: string().required('Description is required'),
    });

    useEffect(() => {
        apiRequest({
            method: 'GET',
            endpoint: apiPath.feedbackCategories,
            params: {
                ids: '43,44'
            }
        })
            .then((res) => {
                console.log(res.data, "cateeee")
                setcategoriesList(res.data);
            })
            .catch((err) => {
                console.log(err);
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                  });
            });
    }, []);

    const saveApiCall = () => {
        const reqBody = {
            name: formData.name,
            email: formData.email,
            categoryId: selectedValue,
            feedback: formData.description
        };
        console.log("reqBody", reqBody)
        apiRequest({
            method: 'POST',
            endpoint: apiPath.feedbackApi,
            body: JSON.stringify(reqBody),
            includeToken: true
        })
            .then((res) => {
                console.log(res);
                const successMessage = LOCALE.FEEDBACK_SUCCESS;
                // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
                //     duration: 10000
                // });
                toast.custom(<SuccessPopup headerMessage="Feedback" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen} />,
                {
                  duration: constants.TOAST_POPUP_DURATION,
                });
                setSelectedValue(null)
                setFormData({
                    name: "",
                    email: "",
                    President: false,
                    Chairman: false,
                    // president: false,
                    // chairman: false,
                    description: ""
                })
            })
            .catch((err) => {
                console.log(err);
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                  });
            });
    };
    const handleCaptchaVerify = (response: any) => {
        // Handle the verification result, you might want to send this to your server.
        console.log("Captcha Response:", response);
        setIsCaptchaVerified(true);
    };

    const handlSubmit = async () => {
        const errors: ErrorMessageTypes = {
            name: "",
            email: "",
            description: ""
        }
        try {
            // Validate the form data against the validation schema
            await validationSchema.validate(formData, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessage(errors);
            // Call your API or perform other actions here
            saveApiCall();

        } catch (error) {
            // Handle validation errors

            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypes] = e.message;
                    }
                });
            }
            setErrorMessage(errors);
        }
    }

    const validateEmail = () => {
        const { email } = formData;
    
        if (email.length < 6) {
          setErrorMessage({
            ...errorMessage,
            email: "Email must be at least 6 characters long.",
          });
        } else if (email.length >= 64) {
          setErrorMessage({
            ...errorMessage,
            email: "Email must be less than 64 characters long.",
          });
        } else if (!email.includes("@")) {
          setErrorMessage({
            ...errorMessage,
            email: "Please Enter Valid Email",
          });
        } else {
          setErrorMessage({ ...errorMessage, email: "" });
        }
      };

    const handleFieldChange = (field: string, value: any) => {

        setFormData({
            ...formData,
            [field]: value,
        });

    };


    const handleRadioChange = (event: any) => {
        setSelectedValue(Number(event.target.value));
    };
    const radioButtons = (): React.ReactElement => {
        return (
            <RadioGroup sx={{ display: "flex", flexDirection: "row" }}
                value={selectedValue}
                onChange={handleRadioChange}
            >
                {categoriesList.map((categorie, index) => (
                    <FormControlLabel control={<CustomRadioButton value={Number(categorie.id)} sx={{ '& .MuiSvgIcon-root': { fontSize: 10 } }} />} label={categorie.name} />
                ))}

                {/* <FormControlLabel control={<CustomRadioButton value="Chairman" sx={{ '& .MuiSvgIcon-root': { fontSize: 10 } }} />} label="Chairman" /> */}
            </RadioGroup>
        )
    }
    const handleKeyDown = (e: any, fieldName: string) => {
        // Prevent entering numeric characters
        if ((e.key >= '0' && e.key <= '9') || /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-=`|"]/.test(e.key)) {
            e.preventDefault();
        }
    };
    return (
        <>
            <Toaster />
            <div className={styles.FeedbackLayout}>
                <Typography className={styles.typoGraphyHeading}>
                    Send Feedback
                </Typography>
                <Card className={styles.cardContainer}>
                    <div className={styles.formFields}>
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={3} item>
                                {CustomRequiredInputLabel("Name", true)}
                                <CustomTextFeild
                                    fullWidth
                                    required
                                    value={formData.name}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;

                                        if (inputValue.length > 50) {
                                            setErrorMessage({ ...errorMessage, name: 'Name should not exceed 50 characters.' });
                                        } else {
                                            handleFieldChange("name", inputValue);
                                            setErrorMessage({ ...errorMessage, name: '' });
                                        }
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, "name")}
                                    className={errorMessage.name ? styles.errorTextField : styles.textField}
                                    placeholder="Enter Name"
                                />
                                {errorMessage.name ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.name}</Typography> : ''}
                            </Grid>
                            <Grid xs={12} sm={3} item>
                                {CustomRequiredInputLabel("Email", true)}
                                <CustomTextFeild
                                    fullWidth
                                    required
                                    value={formData.email}
                                    onChange={(e) => {
                                        handleFieldChange("email", e.target.value);
                                        setErrorMessage({ ...errorMessage, email: '' })
                                    }}
                                    onBlur={validateEmail}
                                    className={errorMessage.email ? styles.errorTextField : styles.textField}
                                    placeholder="Enter Email"
                                />
                                {errorMessage.email ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.email}</Typography> : ''}
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ marginTop: "20px" }}>
                            <Grid xs={12} sm={3} item>
                                <Typography className={styles.header}>Feedback Comment To</Typography>
                                {radioButtons()}
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ marginTop: "20px" }}>
                            <Grid xs={12} sm={3} item>
                                {CustomRequiredInputLabel("Description", true)}
                                <TextareaAutosize
                                    style={{ height: "89px" }}
                                    className={errorMessage.description ? styles.errorTextArea : styles.textArea}
                                    value={formData.description}
                                    onChange={(e) => {
                                        handleFieldChange("description", e.target.value);
                                        setErrorMessage({ ...errorMessage, description: '' })

                                    }} />
                                {errorMessage.description ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.description}</Typography> : ''}
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={2}
                            sx={{ display: 'flex', alignItems: 'center', marginTop: "25px" }}
                        >
                            {/* <CustomCheckbox /> */}
                            <ReCAPTCHA
                                sitekey="6LfU7-QUAAAAAICECh7JUCI-gEC9cZ-kAxJviFCR" 
                                onChange={handleCaptchaVerify}
                            />
                            {/* <Typography className={styles.checkboxtext}>I am not a robot</Typography>
                            <img src='/images/captcha.png' className={styles.images} /> */}
                        </Grid>
                    </div>
                </Card>
                <CommonButton onClick={handlSubmit} sx={{ width: "83px", height: "38px" }}>Submit</CommonButton>
            </div>
        </>
    )
}
export default Feedback;